import styled from "styled-components";
import { fontNormal, fontBold } from "../../_static/Typography";
import buildColor from "../../_static/ColorPalette";

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  background-color: ${buildColor("white", "100")};
  padding: 12px;
`;

export const Title = styled.p`
  font-family: ${fontBold};
  font-size: 16px;
  line-height: 22px;
  color: ${buildColor("grey", "900")};
  margin-bottom: 8px;
`;

export const Description = styled.p`
  font-family: ${fontNormal};
  font-size: 14px;
  line-height: 18px;
  color: ${buildColor("grey", "800")};
`;

export const List = styled.ul`
  margin-top: 12px;
`;

export const ListItem = styled.li`
  &:not(:last-child) {
    margin-bottom: 12px;
  }
`;

export const SelectContainer = styled.div`
  margin-top: 12px;
`;

export const ButtonContainer = styled.div`
  padding-top: 24px;
`;
